import { render, staticRenderFns } from "./yaklasikmaliyettenaktar.vue?vue&type=template&id=4e2a5ae6&"
import script from "./yaklasikmaliyettenaktar.vue?vue&type=script&lang=js&"
export * from "./yaklasikmaliyettenaktar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports